<template>
  <div class="uploadReport">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>报表填报
      </span>
      <span class="other more" @click="toMore()">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="uploadReport-main">
      <div class="left-part">
        <div class="content">
          <div class="contentInfo">
            <!-- <div class="title">{{reprotFormulate.FormluateName}}</div> -->
            <div class="title" @click="toList()" style="cursor: pointer;">{{reprotFormulate.FormluateName}}</div>
            <div class="ft12 ub info-item ft-14">
              <span class="col-66 line">填报时间：</span>
              <p class="ft-wet col-66" v-if="reprotFormulate.StartTime">
                {{reprotFormulate.StartTime|formatDate('yyyy-MM-dd')}}
                至{{reprotFormulate.EndTime|formatDate('yyyy-MM-dd')}}
              </p>
            </div>
          </div>
          <!-- <div ref="echarsDemo" class="echarsDemo"></div> -->
        </div>
        <div class="footer" @click="toList()" style="cursor: pointer;">
        <!-- <div class="footer"> -->
          <div class="ub ub-ac">
            <div class="ft12 footer-label">完成进度</div>
            <div class="ub-f1">
              <el-progress
                :stroke-width="14"
                color="#409EFF"
                :show-text="true"
                :text-inside="true"
                class="col-33"
                :percentage="parseFloat(percentage)"
              ></el-progress>
            </div>
            <div class="footer-item col-66 ft12">
              <!-- <span class="col-gre" v-if="totalCount==0">发送中...</span> -->
              <span v-if="totalCount!==0">
                <svg-icon style="color:#0f77f2;margin:0 2px" iconClass="finish"></svg-icon>
                有在管项目的独立法人企业数量 {{totalCount}} 个
              </span>
              <span v-if="totalCount!==0">
                <span class="col-gre">,已完成{{finishCount}}个</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from "@/assets/js/commonTitle.js";
import { mapState } from "vuex";
import { MyWorkControllerSvr } from "@/service/MyWorkControllerSvr";
import { FormulateControllerSvr } from "@/service/FormulateControllerSvr.js";
import { ReprotFormulate } from "@/models/ReprotFormulate.js";
import { ReportFillControllerSvr } from "@/service/ReportServiceMgeSvr/ReportFillControllerSvr";
import { ReprotFill } from "@/models/report/ReprotFill.js";
import { ReprotFillQueryPara } from "@/models/queryparams/ReprotFillQueryPara.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      KeyId: "",
      Position: "4",
      tableData: [],
      loading: true,
      totalCount: 0,
      finishCount: 0,
      percentage: 0,

      reprotFormulate: new ReprotFormulate(),
      reportFillControllerSvr: new ReportFillControllerSvr(),
      reprotFillQueryPara: new ReprotFillQueryPara()
    };
  },
  computed: {
    ...mapState(["token"])
  },
  created() {
    this.formulateControllerSvr = new FormulateControllerSvr();
    this.reprotFormulate = new ReprotFormulate();
    this.reportFillControllerSvr = new ReportFillControllerSvr();
    this.reprotFillQueryPara = new ReprotFillQueryPara();
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.loading = true;
      this.formulateControllerSvr
        .GetLastReportFormulat(this.token)
        .then(res => {
          if (res != null) {
            this.KeyId = res.KeyId;
            this.reprotFormulate = res;
            this.reprotFillQueryPara.setParamByFormluateKeyId(res.KeyId);
            //查询总数

            this.reportFillControllerSvr.getReportRate(this.token,res.KeyId).then(
              res =>{
                   if (res != null) {
                     this.totalCount=res.total;
                     this.finishCount =res.finish;
                      this.percentage = this.finishCount == 0? 0: ((this.finishCount / this.totalCount) * 100).toFixed(2);
                   }
              }
            );
          }
        });
    },
    gowork(item) {},
    toMore() {
      this.$router.push({
        path: "propertyDeclareAdd",
        query: { t: Date.now() }
      });
    },
    toList() {
      this.$router.push({
        path: "propertyDeclareAdd",
        query: { FormluateKeyId: this.KeyId,isShow: 3 }
      });
    }
  }
};
</script>
<style lang="scss">
@import "./css/common.scss";
.uploadReport {
  background-color: #fff;
  .uploadReport-main {
    text-align: center;
    height: 130px;
    padding-left: 20px;
    .left-part {
      height: 100%;
      min-width: 450px;
      .content {
        .contentInfo {
          width: calc(50% - 10px);
          min-height: 60px;
          padding: 15px 0;
          .title {
            text-align: left;
            font-weight: 600;
            border-left: 4px solid #0f77f2;
            padding-left: 8px;
            // cursor: pointer;
            // &:hover {
            //   color: #0e76f1;
            //   transition: all 0.3s;
            // }
          }
          .line {
            line-height: 1.6;
          }
          .ft-wet {
            font-weight: 600;
            line-height: 1.6;
            word-break: break-word;
          }
          .info-item {
            margin-top: 20px;
          }
        }
      }
      .footer {
        // cursor: pointer;
        height: 30px;
        margin: 0 10px;
        border-top: 1px solid #e2e2e2;
        .col-gre {
          color: #7cc562;
        }
        & > div {
          height: 35px;
        }
        .footer-label {
          margin-right: 10px;
        }
        .footer-item {
          width: 200px;
          margin: 0 10px;
        }
        .el-progress-bar__innerText {
          color: #333;
        }
      }
    }
  }
}
</style>
